<template>
  <div class="get-reviewed">
    <div class="heading">Get Reviewed</div>

    <div class="upgrade-items">
      <div class="upgrade-heading">Choose your review options</div>

      <turnaround-option
        :book="book"
        :onSelect="onTurnaroundSelect"
      ></turnaround-option>

      <div
        v-if="book.is_standard_readers"
        class="upgrade-item upgrade-item-standard"
      >
        <div
          class="upgrade-checkbox"
          :class="{ 'upgrade-checkbox-checked': isStandard }"
          @click="clickStandard"
        >
          <i class="material-icons checkbox-icon">{{
            isStandard ? "check_box" : "check_box_outline_blank"
          }}</i>
        </div>
        <div class="upgrade-label">
          <span @click="clickStandard" style="cursor: pointer"
            >Standard</span
          >
          <div class="upgrade-more">
            <p>
              Your reader will download and read your book from Pubby, then review it on Amazon.
            </p>
            <div v-if="isStandard" class="upgrade-price">
              <div class="input-label">Your Book File
                <download-manuscript :book="book">DOWNLOAD</download-manuscript>
              </div>
            </div>
          </div>
        </div>
        <div class="item-cost">
          <div class="points-tag">
            <div class="points-icon">
              <!-- <img src="/images/icons/snap.svg" class="snaps-icon" /> -->
            </div>
            <!-- <div class="points-number">Free</div> -->
          </div>
        </div>
      </div>

      <div
        v-if="book.is_kindle_readers"
        class="upgrade-item upgrade-item-kindle"
      >
        <div
          class="upgrade-checkbox"
          :class="{ 'upgrade-checkbox-checked': isKindle }"
          @click="clickKindle"
        >
          <i class="material-icons checkbox-icon">{{
            isKindle ? "check_box" : "check_box_outline_blank"
          }}</i>
        </div>
        <div class="upgrade-label">
          <span @click="clickKindle" style="cursor: pointer"
            >Kindle Unlimited</span
          >
          <div class="upgrade-more">
            <p>
              Your reader will read and review your book using Kindle Unlimited.
            </p>
            <p>
              Amazon does not label reviews from a Kindle Unlimited reader
              as a Verified Purchase review.
            </p>
          </div>
        </div>
        <div class="item-cost">
          <div v-if="selected==='kindle'" class="points-tag" :class="{pulseOnce: shakeKindle}">
            <div class="points-increase">+</div>
            <div class="points-icon">
              <img src="/images/icons/snap.svg" class="snaps-icon" />
            </div>
            <div class="points-number">200</div>
          </div>
        </div>
      </div>

      <div
        v-if="book.is_verified_readers"
        class="upgrade-item upgrade-item-verified"
        :class="{ disabled: this.book.is_vp_suspended }"
      >
        <div
          class="upgrade-checkbox"
          :class="{ 'upgrade-checkbox-checked': isVerified }"
          @click="clickVerified"
        >
          <i class="material-icons checkbox-icon">{{
            isVerified ? "check_box" : "check_box_outline_blank"
          }}</i>
        </div>
        <div class="upgrade-label">
          <span @click="clickVerified" style="cursor: pointer"
            >Verified Purchase</span
          >
          <div v-if="isVerified" class="upgrade-price">
            <div class="input-label">Your Book's Price</div>
            <div class="input-box">
              <v-radio-group
                v-model="selectedPrice"
                @change="selectOption('verified')"
                row
              >
                <v-radio
                  class="star-radio"
                  v-for="n in ['Free Promotion', '$0.99', '$1.99', '$2.99', '$3.99', '$4.99']"
                  :key="n"
                  :label="`${n}`"
                  :value="n"
                  :color="'#ff8762'"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="upgrade-more">
            <p v-if="this.book.is_vp_suspended">
              Your ability to request Verified Purchase reviews has been suspended.
            </p>
            <span v-else-if="isVerified">
              <p>Your reader will purchase your book and leave a Verified Purchase
              review.</p>
              <p>If you'd like, you can also schedule when to look for reviews to ensure your book is priced appropriately. <br><span class="extra-text">Scheduled availability will use {{ timezoneText }} in order to align with the timezone Kindle uses.</span></p>
              <div class="upgrade-more">
                <VueDatePicker 
                  class="date-picker"
                  v-model="liveDates" 
                  local="{lang: 'en'}"
                  range
                  clearable
                  :min-date="minDate"
                  :max-date="maxDate"
                  fixed-start
                  placeholder="Schedule Review"
                  range-header-text="From %d to %d"
                  range-input-text="%d to %d"
                  format="MM-DD-YYYY"
                  format-header="MM-DD-YYYY"
                  >
                  <template #input-icon>
                    <i class="material-icons calendar-icon">date_range</i>
                  </template>
                </VueDatePicker>
              </div>
            </span>
            <p v-else>
              Your reader will purchase your book and leave a Verified Purchase
              review.
            </p>
          </div>
        </div>
        <div class="item-cost">
          <div v-if="selected==='verified'" class="points-tag" :class="{pulseOnce: shakeVerified}">
            <div class="points-increase">+</div>
            <div class="points-icon">
              <img src="/images/icons/snap.svg" class="snaps-icon" />
            </div>
            <div class="points-number">{{ verifiedPoints }}</div>
          </div>
        </div>
      </div>

<!-- Disabled Recommended Reader function
      <div class="upgrade-item upgrade-item-star-protection">
        <div
          class="upgrade-checkbox"
          :class="{ 'upgrade-checkbox-checked': isRecommendedReaders }"
          @click="clickStarProtection"
        >
          <i class="material-icons checkbox-icon">{{
            isRecommendedReaders ? "check_box" : "check_box_outline_blank"
          }}</i>
        </div>
        <div class="upgrade-label">
          <span @click="clickStarProtection" style="cursor: pointer"
            >Recommended Reader</span
          >
          <div class="upgrade-more">
            <p>
              We'll find a reader who is likely to enjoy your book based on
              their reading history. It may take longer to find a reader.
            </p>
          </div>
        </div>
        <div class="item-cost">
          <div class="points-tag">
            <div class="points-icon">
              <img src="/images/icons/snap.svg" class="snaps-icon" />
            </div>
            <div class="points-number">150</div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="total-snaps">
      <div class="total-label">Total:</div>
      <div class="item-cost">
        <div class="points-tag">
          <div class="points-icon">
            <img src="/images/icons/snap.svg" class="snaps-icon" />
          </div>
          <div class="points-number">{{ totalPoints }}</div>
        </div>
      </div>
    </div>

    <!-- <div class="options" style="display:none">
      <div
        class="option standard"
        :class="{'selected': selected === 'standard'}"
        ref="standard"
        @click="selectOption('standard')"
      >
        <div class="option-heading">
          <div class="option-icon">
            <i class="material-icons">query_builder</i>
          </div>
          <div class="option-label">Standard</div>
          <div class="clearfix"></div>
        </div>
        <div class="description">A reader will review your book within 72 hours.</div>
        <div class="point">
          <div class="label">Snaps</div>
          <div class="value">{{ options.standard.points | bigNumber }}</div>
        </div>
        <div class="point">
          <div class="label">Due Date</div>
          <div class="value">{{ book.proposed_standard_due_at | shortDate }}</div>
        </div>
      </div>
      <div
        class="option speedy"
        :class="{'selected': selected === 'speedy'}"
        ref="speedy"
        @click="selectOption('speedy')"
      >
        <div class="option-heading">
          <div class="option-icon">
            <i class="material-icons">restore</i>
          </div>

          <div class="option-label">Speedy</div>
          <div class="clearfix"></div>
        </div>
        <div class="description">A reader will review your book within 24 hours.</div>
        <div class="point">
          <div class="label">Snaps</div>
          <div class="value">{{ options.speedy.points | bigNumber }}</div>
        </div>
        <div class="point">
          <div class="label">Due Date</div>
          <div class="value">{{ book.proposed_speedy_due_at | shortDate }}</div>
        </div>
      </div>
    </div>-->
    <div class="actions">
      <div
        class="action grow"
        :class="{
          'action-disabled': !selected,
          'earn-points': notEnoughPoints,
          'disabled': lockActionInProgress, 
        }"
        @click="actionClicked"
      >
        {{ actionLabel }}
      </div>
      <div class="confirm-text" v-if="canConfirm">
        You'll have {{ pointsSurplus | bigNumber }} snaps left.
      </div>
      <div class="confirm-text" v-if="notEnoughPoints">
        You need {{ pointsDeficit | bigNumber }} more snaps.
      </div>
    </div>
  </div>
</template>

<script>
import Back from "@/modules/Back";
import Bus from "@/modules/Bus";
import moment from "moment-timezone";
import TurnaroundOption from "./TurnaroundOption";
import DownloadManuscript from "./DownloadManuscript";
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

export default {
  name: "GetReviewed",
  props: ["book"],
  components: {
    DownloadManuscript,
    TurnaroundOption,
    VueDatePicker
  },
  data: function () {
    return {
      options: null,
      selected: "standard",
      disabled: true,
      lockActionInProgress: false,
      canConfirm: true,
      notEnoughPoints: null,
      pointsDeficit: null,
      pointsSurplus: null,
      isStandard: false,
      isKindle: false,
      isVerified: false,
      isSpeedy: false,
      isRecommendedReaders: false,
      minDate: null,
      maxDate: null,
      liveDates: null,
      selectedPrice: null,
      turnaroundOptionValue: 0,
      turnaroundOptionPoints: 0,
      shakeKindle: false,
      shakeVerified: false,
    };
  },
  computed: {
    totalPoints() {
      let points = this.book.points;

      if (this.isSpeedy) {
        points += 400;
      }
      if (this.isKindle) {
        points += 200;
      }
      if (this.isRecommendedReaders) {
        points += 150;
      }

      if (this.isVerified) {
        points += this.verifiedPoints;
      }

      points += this.turnaroundOptionPoints;

      return points;
    },
    verifiedPoints() {
      switch (this.selectedPrice) {
        case "Free Promotion":
          return 0;
        case "$0.99":
          return 300;
        case "$1.99":
          return 600;
        case "$2.99":
          return 900;
        case "$3.99":
          return 1200;
        case "$4.99":
          return 1500;
      }

      return 300;
    },
    actionLabel() {
      if (this.notEnoughPoints) {
        return "Earn Snaps";
      }

      return this.selected ? "Get Reviewed" : "Select Option";
    },
    pointsLeft() {},
    standardProposedDueAt() {
      const now = new Date();
    },
    speedyProposedDueAt() {},
    timezoneText() {
      return moment().tz("America/Los_Angeles").format('z')
    },
  },
  mounted() {
    this.isStandard = this.book.is_standard_readers
  },
  methods: {
    flashPointsChange(value) {
      switch (value) {
        case "kindle":
          this.shakeKindle = true
          setTimeout(() => {
            this.shakeKindle = false;
            }, 500);
          break;
        case "verified":
          this.shakeVerified = true
          setTimeout(() => {
            this.shakeVerified = false;
            }, 600);
          break;
      }
    },
    clickStandard() {
      this.isStandard = !this.isStandard;
      if (this.isStandard) {
        this.isVerified = false
        this.isKindle = false
        this.selectOption("standard");
      } else if (this.selected=="standard") {
        this.selectOption("");
      }
    },
    clickVerified() {
      this.isVerified = !this.isVerified;
      if (this.isVerified) {
        this.isStandard = false
        this.isKindle = false
        this.selectOption("verified");
      } else if (this.selected=="verified") {
        this.selectOption("");
      }
    },
    clickKindle() {
      this.isKindle = !this.isKindle;
      if (this.isKindle) {
        this.isStandard = false
        this.isVerified = false
        this.selectOption("kindle");
      } else if (this.selected=="kindle") {
        this.selectOption("");
      }
    },
    clickSpeedy() {
      this.isSpeedy = !this.isSpeedy;
      this.selectOption("standard");
    },
    clickStarProtection() {
      this.isRecommendedReaders = !this.isRecommendedReaders;
      this.selectOption("standard");
    },
    selectOption(value) {
      this.selected = value;
      this.flashPointsChange(value)
      const currentPoints = this.$store.state.points;
      const neededPoints = this.totalPoints;

      if (currentPoints < neededPoints) {
        this.notEnoughPoints = true;
        this.canConfirm = false;
        this.pointsDeficit = neededPoints - currentPoints;
        this.pointsSurplus = 0;
      } else {
        this.notEnoughPoints = false;
        this.canConfirm = true;
        this.pointsDeficit = 0;
        this.pointsSurplus = currentPoints - neededPoints;
      }

      // console.log("selectOption", value, this.selected);
    },
    onTurnaroundSelect(value, points) {
      // console.log("onTurnaroundSelect", value);

      this.turnaroundOptionValue = value;
      this.turnaroundOptionPoints = points;

      this.selectOption("standard");
    },
    async actionClicked() {
      if (this.notEnoughPoints) {
        this.$router.push("/snaps");
        return;
      }

      if (!this.selected || !this.canConfirm) {
        return;
      }

      if (this.isVerified && this.isKindle) {
        this.$toasted.show(
          "Please select either Kindle Unlimited or Verified Purchase. Both cannot be used for the same review.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
        return;
      }

      if (
        !this.book.is_standard_readers &&
        !this.isVerified &&
        !this.isKindle
      ) {
        var readersLabel = "";
        if (this.book.is_kindle_readers && this.book.is_verified_readers) {
          readersLabel =
            "either Kindle Unlimited or Verified Purchase so that your reader knows how to read the book";
        } else if (this.book.is_kindle_readers) {
          readersLabel =
            "the Kindle Unlimited option so that your reader knows to use Kindle Unlimited to read the book";
        } else if (this.book.is_verified_readers) {
          readersLabel =
            "the Verified Purchase option so that your reader knows to purchase the book from Amazon";
        }

        this.$toasted.show(
          "Your book does not have a book file provided for it. Please select " +
            readersLabel +
            ".",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
        return;
      }

      if (this.isVerified && !this.selectedPrice) {
        this.$toasted.show(
          "Please select your book's price under 'Verified Purchase' and try again.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
        return;
      }

      if (!this.turnaroundOptionValue) {
        this.$toasted.show(
          "Please click one of the green circles below 'Turnaround Time' to select the number of days your reader is given to read your book.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 7000,
          }
        );
        return;
      }

      try {
        this.lockActionInProgress = true
        // If there are open or close dates, grab them and convert them to PT (the schedule time used by Kindle)
        let openedAt = null
        let closedAt = null
        if (this.liveDates && this.liveDates.start) {
          // openedAt = addHours(this.liveDates.start, 8)
          openedAt = moment(this.liveDates.start).tz('America/Los_Angeles')
          // If it's already the "launch day" in PT, don't add a start date
          if (openedAt.isSame(this.minDate,'day')) {
            openedAt = null
          }
        }
        if (this.liveDates && this.liveDates.end) {
          // closedAt = addHours(this.liveDates.end ,8)
          closedAt = moment(this.liveDates.end).tz('America/Los_Angeles')
        }

        const assignment = await Back.upBook(this.book, {
          turnaround_days: this.turnaroundOptionValue,
          is_speedy: this.isSpeedy,
          is_verified: this.isVerified,
          is_kindle: this.isKindle,
          is_recommended_readers: this.isRecommendedReaders,
          listing_price: this.selectedPrice,
          opened_at: openedAt,
          closed_at: closedAt,
        });

        // console.log("up result", assignment);

        if (!assignment) {
          this.$toasted.show(
            "Oops! Something went wrong. Please try again later.",
            {
              icon: "error",
              position: "bottom-center",
              duration: 3000,
            }
          );
          this.lockActionInProgress = false
          return;
        }

        if (assignment.message) {
          this.$toasted.show(
            assignment.message,
            {
              icon: "error",
              position: "bottom-center",
              duration: 3000,
            }
          );
        } else if (assignment) {
          this.$toasted.show(
            "Great! We'll start finding a reader for " +
              this.book.title +
              " right now!",
            {
              icon: "check_circle",
              position: "bottom-center",
              duration: 3000,
            }
          );
        }

        this.lockActionInProgress = false
        this.$store.commit("stopChoosingReview");
        Bus.$emit("UserChanged", this.book);
      } catch (err) {
        this.lockActionInProgress = false
        console.log("up err", err);
      }

      console.log("going ahead");
    },
  },
  created() {
    this.minDate = addDays(moment(new Date()).startOf('day').tz('America/Los_Angeles'),0)
    this.maxDate = addDays(moment(new Date()).endOf('day').tz('America/Los_Angeles'),30);

    this.options = {
      standard: {
        points: this.book.points,
      },
      speedy: {
        points: this.book.points + 400,
      },
    };

    this.selectOption("standard");
  },
};

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function addHours(date, hours) {
  var result = new Date(date);
  result.setTime(result.getTime() + (hours*60*60*1000));
  return result;
}

</script>

<style lang="scss" scoped>
.single .get-reviewed {
  zoom: 0.85 !important;
}
.standard-item {
  width: 100%;
  padding: 20px 0 12px 0;
  border-bottom: 0px solid #eee;
  display: flex;

  .standard-label {
    padding-left: 20px;
    padding-top: 2px;
    font-size: 17pt;
    font-weight: 600;
    color: $color-blue;
  }

  .standard-more {
    padding-left: 1px;
    padding-top: 2px;
    font-size: 12pt;
    font-weight: 500;
    color: #111;
  }

  .item-cost {
    margin-top: 3px;
  }
}
.item-cost {
  margin-left: auto;
}

.upgrade-items {
  padding: 10px 0;

  .upgrade-heading {
    background: lighten(#fff, 0%);
    border-top: 2px solid #f1f1f1;
    border-radius: 4px 4px 0 0;
    border-bottom: 0;
    padding-left: 67px;
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 11.5pt;
    font-weight: 700;
    color: #777;
    text-transform: uppercase;
  }
}

.upgrade-item {
  width: 100%;
  padding: 12px 0 12px 0;
  border-top: 2px solid #f3f3f3;
  display: flex;

  .upgrade-checkbox {
    margin: 0px 0px 4px 20px;
    width: 28px;
    min-width: 28px;
    height: 32px;
    background: #fff;
    border: 0px solid #eee;
    border-radius: 4px;
  }

  // .checkbox-icon {
  //   color: #ccc;
  // }

  .upgrade-label {
    padding-left: 20px;
    padding-top: 2px;
    font-size: 15pt;
    font-weight: 600;
    color: $color-blue;
  }

  .upgrade-more {
    padding-left: 1px;
    padding-top: 6px;
    font-size: 13pt;
    font-weight: 500;
    line-height: 1.35em;
    color: #111;

    p {
      font-size: 12pt;
      padding: 0;
      margin-bottom: 10px;
    }
  }
}

.upgrade-manuscript-required {
  padding-left: 1px;
  padding-top: 6px;
  font-size: 13pt;
  font-weight: 500;
  line-height: 1.35em;
  color: #111;
}

.upgrade-item-speedy {
  .upgrade-label {
    color: lighten(#43a047, 1%);
  }
  .checkbox-icon {
    color: lighten(#43a047, 37%);
  }
  .checkbox-icon:hover {
    color: lighten(#43a047, 28%);
    cursor: pointer;
  }
  .upgrade-checkbox-checked .checkbox-icon {
    color: lighten(#43a047, 5%);
  }
  .upgrade-checkbox-checked .checkbox-icon:hover {
    color: darken(#43a047, 0%);
  }
}
.upgrade-item-standard {
  .upgrade-label {
    color: lighten($color-blue, 1%);
  }
  .checkbox-icon {
    color: lighten($color-blue, 17%);
  }
  .checkbox-icon:hover {
    color: lighten($color-blue, 8%);
    cursor: pointer;
  }
  .upgrade-checkbox-checked .checkbox-icon {
    color: lighten($color-blue, 5%);
  }
  .upgrade-checkbox-checked .checkbox-icon:hover {
    color: darken($color-blue, 0%);
  }
}
.upgrade-item-verified {
  .upgrade-label {
    color: lighten($color-snaps, 0%);
  }
  .checkbox-icon {
    color: lighten($color-snaps, 25%);
  }
  .checkbox-icon:hover {
    color: lighten($color-snaps, 17%);
    cursor: pointer;
  }
  .upgrade-checkbox-checked .checkbox-icon {
    color: lighten($color-snaps, 6%);
  }
  .upgrade-checkbox-checked .checkbox-icon:hover {
    color: lighten($color-snaps, 1%);
  }
}
.upgrade-item-kindle {
  .upgrade-label {
    color: darken(#e9a23b, 5%);
  }
  .checkbox-icon {
    color: lighten(#e9a23b, 27%);
  }
  .checkbox-icon:hover {
    color: lighten(#e9a23b, 20%);
    cursor: pointer;
  }
  .upgrade-checkbox-checked .checkbox-icon {
    color: #e9a23b;
  }
  .upgrade-checkbox-checked .checkbox-icon:hover {
    color: darken(#e9a23b, 5%);
  }
}
.upgrade-item-star-protection {
  .upgrade-label {
    color: lighten(#b45ac3, 6%);
  }
  .checkbox-icon {
    color: lighten(#b45ac3, 28%);
  }
  .checkbox-icon:hover {
    color: lighten(#b45ac3, 21%);
    cursor: pointer;
  }
  .upgrade-checkbox-checked .checkbox-icon {
    color: #b45ac3;
  }
  .upgrade-checkbox-checked .checkbox-icon:hover {
    color: darken(#b45ac3, 0%);
  }
}

.checkbox-icon {
  font-size: 27pt !important;
}

.extra-text {
  color: #838383;
}

.calendar-icon {
  color: $color-blue;
}

.date-picker {
  display: inline-block;
  margin-left: 1em;
  scale: 1.2;
  color: lighten($color-blue, 1%);
}

.total-snaps {
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0;
  padding: 8px 0 0 0;

  .item-cost {
    zoom: 1.05;
  }

  .total-label {
    padding: 8px 4px 0 20px;
    font-size: 14pt;
    font-weight: 500;
    color: #222;
  }

  .item-cost {
    margin-left: 0;
  }
}

.actions {
  padding: 12px;
  text-align: center;
}
.action {
  display: inline-block;

  min-width: 164px;
  border-radius: 4px;
  padding: 8px 16px 9px 16px;
  font-size: 12pt;
  font-weight: 700;
  text-transform: none;
  font-family: "Source Sans Pro";
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1px;

  background: lighten(#ffe0b2, 8%) !important;
  border: 2px solid #ffe0b2;
  color: #f57c00;

  background: #fdead0 !important;
  padding: 8px 16px 9px;
  color: #f57c00;
  border: 0 !important;
}
.disabled {
  // background: #ececec !important;
  background: #f4f4f4 !important;
  // color: #aaa !important;
  pointer-events: none !important;
  box-shadow: 0 0 8px 8px #fff inset;
  .upgrade-checkbox {
    background: #f4f4f4
  }
  .checkbox-icon {
    color: #8b8b8b;
  }
  .upgrade-label {
    // background: #ececec ;
    color: #8b8b8b;
    // color: #aaaaaa;
  }
  .upgrade-more {
    color: #acacac;
  }
}
.get-reviewed {
  padding: 0px 16px 12px 16px;
}
.earn-points {
  background: #daedff !important;
  color: #2196f3 !important;
  border: 2px solid darken(#daedff, 5%) !important;
}

.heading {
  display: none;
  padding: 0 0 1em 0;
  font-size: 15pt;
  font-weight: 600;
  color: #999;
  text-align: center;
}

.options {
  display: flex;
}

.option {
  flex-grow: 1;
  border: 3px solid #fff;
  padding: 16px;
  margin: 0 2px;
  break-after: always;
  width: 100%;
}
.breaker {
  display: block;
  width: 100%;
  height: 0;
}
.option:hover {
  background: #fcfcfc;
  border: 3px solid #eee;
  border-radius: 16px;
  cursor: pointer;
}
.standard.selected {
  background: #f2fff1;
  border: 3px solid #bceabd;
  border-radius: 16px;
}
.speedy.selected {
  background: #fff5f5;
  border: 3px solid #f5c39c;
  border-radius: 16px;
}

.option-heading {
  margin: 0 auto;
  font-size: 15pt;
  font-weight: 700;
  text-align: center;
  line-height: 1.5em;
}
.option-icon {
  float: left;
  margin-top: 2px;
  font-size: 16pt !important;
}
.option-label {
  float: left;
  margin: 0px 0 0 4px;
  font-size: 16pt !important;
}

.standard .option-heading {
  width: 124px;
  color: #4caf50;
}
.speedy .option-heading {
  width: 110px;
  color: #ef6c00;
}

.description {
  font-size: 12pt;
  padding: 0.5em 0em 1.5em 0em;
  line-height: 1.25em;
  text-align: center;
}

.point {
  margin: 0px 0;
  padding: 1px 0 1px 36px;
}
.label {
  display: inline-block;
  width: 86px;
  font-size: 12pt;
  font-weight: 700;
  color: #2196f3;
  font-family: "Source Sans Pro";
}
.value {
  display: inline-block;
  width: 100px;
  font-size: 12pt;
  font-weight: 300;
  color: #222;
  font-family: "Source Sans Pro";
}

.confirm-text {
  padding: 0.5em 0 0 0;
  font-size: 11.5pt;
  color: #333;
  text-align: center;
}

.points-tag {
  display: flex;
  background: #fff;
  padding: 2px 14px 0 0;

  .points-icon {
    font-size: 24px;
    margin: 0;
    padding: 0;
    padding-left: 1px;
    line-height: 26px;
    color: $color-snaps;
  }

  .points-number {
    padding: 0px 0 0 5px;
    font-size: 14pt;
    font-weight: 600;
    line-height: 25px;
    color: darken($color-snaps, 0%);
  }
  .points-increase {
    padding-right: 5px;
    font-size: 16pt;
    font-weight: 600;
    line-height: 25px;
    color: darken($color-snaps, 0%);
  }
}
.snaps-icon {
  float: left;
  width: 22px;
  margin: 8px 0 0 0px;
}

.input-label {
  padding-top: 8px;
  font-size: 14pt;
  color: #444;
  font-weight: 600;
}
.input-box {
  margin-top: -6px;
}
.pulseOnce {
  animation: pulse .3s normal;
}

@media (max-width: 768px) {
  .options {
    margin-top: 8px;
    display: block;
  }
}
</style>


